import { memo, useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { AsyncPaginate } from "react-select-async-paginate";
import { ForeignData_API } from "../../APIs/ForeignData.api";
import { post } from "jquery";
import { components } from "react-select";

const Component = ({
  field,
  label,
  table_id,
  primary_key,
  onChange,
  setFilterWidth,
  currentWidth,
  handleInputChange,
  dataCal,
  isRegexSearching,
  menuIsOpen,
  setTableFilter,
  popupTable,
  idModal,
  isParam,
}) => {
  const { lang, proxy, functions } = useSelector((state) => state);
  const { normalizeStringAccent } = functions;
  const _token = localStorage.getItem("_token");
  const [data, setData] = useState({
    options: [],
    hasMore: false,
    additional: {
      page: 0,
    },
  });

  const [selectedValue, setSelectedValue] = useState();
  const [isWidth, setWidth] = useState(false);
  const [firstWidth, setFirstWidth] = useState(0);
  const widthRef = useRef(null);

  const filterData = (data, search) => {
    search = normalizeStringAccent(String(search));

    const filteredOptions = data.options.filter((item) => {
      item.label = normalizeStringAccent(String(item?.label));
      return item.label.toLowerCase().includes(search.toLowerCase());
    });

    return {
      ...data,
      options: filteredOptions,
    };
  };
  const handleGetData = async (page = 0, search = "") => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await ForeignData_API.get(proxy(), _token, {
          table_id,
          start_index: page,
          search,
        });
        const { success, data } = res;
        let newData = {
          options: [],
          hasMore: false,
          additional: {
            page: 0,
          },
        };
        if (data && data.length) {
          const alias = res.fields.find(
            (field) => field.id === primary_key
          )?.fomular_alias;

          const uniqueValues = new Set();
          const options = [];
          let maxLength = 0;

          setData((prev) => {
            data.map((item) => {
              const value = item[alias];
              if (!uniqueValues.has(value)) {
                uniqueValues.add(value);
                if (value) {
                  options.push({
                    label: value,
                    value: value,
                    alias: alias,
                  });
                  maxLength = Math.max(maxLength, value.length);
                }
              }
            });
            setWidth(7 * maxLength + 100);
            newData = {
              additional: { page: page + 15 },
              hasMore: res.data.length ? true : false,
              options: options,
            };

            return {
              additional: { page: page + 15 },
              hasMore: res.data.length ? true : false,
              options: [
                ...prev.options,
                ...res.data.map((item) => ({
                  label: item[alias],
                  value: item[alias],
                  alias: alias,
                })),
              ],
            };
          });
        }
        // else if (!data && dataCal) {
        //   const options = [];
        //   const uniqueDataCal = new Set();
        //   dataCal.map((item) => {
        //     if (!uniqueDataCal.has(item)) {
        //       uniqueDataCal.add(item);
        //       if (item) {
        //         options.push({
        //           value: item,
        //           label: item,
        //         });
        //       }
        //     }
        //   });

        //   newData = {
        //     additional: { page: page + 15 },
        //     hasMore: false,
        //     options: options,
        //   };
        // }
        setTimeout(() => {
          resolve(filterData(newData, search));
        }, 100);
      } catch (err) {
        console.log("OPTION ERROR:", err);
        reject(err);
      }
    });
  };
  const handleOnchange = (props) => {
    if (props.length > 0) {
      setSelectedValue(props);
      onChange(props);
    } else {
      setSelectedValue();
      onChange();
    }
  };
  useEffect(() => {
    handleGetData();
    setFirstWidth(widthRef.current.offsetWidth);
    setFilterWidth(widthRef.current.offsetWidth);
  }, []);

  const customStyles = {
    control: (styles, { isSelected }) => ({
      ...styles,
      minHeight: 0,
      height: "34px",
      color: isSelected ? "#888787" : "#888787",
      borderColor: "unset",
      boxShadow: "unset",
      "&:hover": {
        borderColor: "unset",
        boxShadow: "unset",
      },
    }),
    container: (base) => ({
      ...base,
      width: `${currentWidth + 60}px`,
      // width: firstWidth < isWidth ? `${isWidth}px` : null,
      padding: "2px 10px",
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
      marginTop: 11,
      top: popupTable || idModal || isParam ? "auto" : 0,
      boxShadow: 0,
      borderRadius: "0px",
      width: popupTable || idModal || isParam ? "auto" : "100%",
      // left: -10,
      borderRadius: 0,
    }),
    option: (styles, { isSelected, isFocused }) => {
      return {
        ...styles,
        color: "#888787",
        fontWeight: "300",
        cursor: "pointer",
        backgroundColor: isSelected
          ? "#e6e6e6"
          : isFocused
          ? "#e6e6e6"
          : undefined,
        display: "flex",
        alignItems: "center",
      };
    },
    singleValue: (styles) => ({
      ...styles,
      color: "#888787",
    }),
    menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
    valueContainer: (provided) => ({
      ...provided,
      whiteSpace: "nowrap",
      overflow: "hidden",
      flexWrap: "nowrap",
    }),
    multiValueLabel: (base) => ({
      ...base,
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      overflow: "hidden",
    }),
    placeholder: (base) => ({
      ...base,
      maxWidth: "100%",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      overflow: "hidden",
    }),
  };

  const CustomOption = ({ children, ...props }) => {
    return (
      <>
        <components.Option {...props}>
          <input
            type="checkbox"
            checked={props.isSelected}
            onChange={() => null}
            style={{ marginRight: 10 }}
          />
          {children}
        </components.Option>
      </>
    );
  };

  return (
    <div ref={widthRef}>
      <AsyncPaginate
        components={{
          Option: CustomOption,
          DropdownIndicator: () => null,
          IndicatorSeparator: () => null,
        }}
        closeMenuOnSelect={false}
        hideSelectedOptions={false}
        menuPosition={popupTable || idModal || isParam ? null : "fixed"}
        placeholder={lang["type value"]}
        loadOptions={async (search, loadedOptions, { page }) => {
          return await handleGetData(page, search);
        }}
        onChange={(props) => {
          handleOnchange(props);
        }}
        styles={customStyles}
        value={selectedValue}
        additional={{
          page: 0,
        }}
        isMulti
        defaultMenuIsOpen
        menuIsOpen={menuIsOpen}
        noOptionsMessage={() => (
          <div style={{ fontWeight: "300" }}>{lang["not found data"]}</div>
        )}
        allowCreateWhileLoading={false}
      />
    </div>
  );
};
export const Option = memo(Component);
